export default __webpack_public_path__ + "static/logo_footer 1-78eddfb0638845ac1aec6b53ef202b84.svg";